import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import withRouter from "../../custom/withRouter";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import GlobalSettings from "./GlobalSettings";
import SSO from "./SSO";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import { connect } from "react-redux";
import CommonIcon from "../../helpers/icons";
import { ToastContainer } from "react-toastify";
import MeetingConfiguration from "./Meeting/MeetinConfigurationPage";
import TenantAdminSettings from "./TenantAdminSettings";
import API from "../../helpers/endpointservice";
import Actions from "../../../action/api";

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isWebMobile: false, // Or get it from props if necessary: this.props.isWebMobile
      value: "1",
      isSSO: false,
    };
  }
  componentDidMount() {
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    this.getIsSSO();
  }

  getIsSSO = () => {
    Actions.GET(API.IsSSO)
      .then((res) => {
        this.setState({ isSSO: res.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 468) {
      this.setState({
        isMobile600: true,
        isWebMobile: true,
      });
    } else {
      this.setState({
        isMobile600: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.setState({
        isMobile380: true,
      });
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };

  render() {
    const { isWebMobile } = this.state;
    return (
      <>
        {!isWebMobile ? (
          <div className="mainSetting">
            <div className="row ">
              <div className="col-10 mt-2">
                <span className="headerform">Settings</span>
              </div>
            </div>
            <div className="row w-100">
              <div className="col-12 ">
                <TabContext value={this.state.value}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList onChange={this.handleChange}>
                      <Tab
                        sx={{ textTransform: "none" }}
                        label="Global Settings"
                        value="1"
                        className="m1 p0 mr-30"
                      />
                      <Tab
                        sx={{ textTransform: "none" }}
                        label="SSO"
                        value="2"
                        className="p0 mr-30"
                      />
                      <Tab
                        sx={{ textTransform: "none" }}
                        label="Meeting Configuration"
                        value="3"
                        className="p0 mr-30"
                      />
                      <Tab
                        sx={{ textTransform: "none" }}
                        label="Tenant Admin Center"
                        value="4"
                        className="p0 mr-30"
                      />
                    </TabList>
                  </Box>
                  <TabPanel value="1" className="mt-2 ">
                    <GlobalSettings />
                  </TabPanel>
                  <TabPanel value="2" className="mt-3 ">
                    <SSO handleLogout={this.props.handleLogout} isSSO={this.state.isSSO} />
                  </TabPanel>
                  <TabPanel value="3" className="mt-2 ">
                    <MeetingConfiguration />
                  </TabPanel>
                  <TabPanel value="4" className="mt-3">
                    <TenantAdminSettings />
                  </TabPanel>
                </TabContext>
              </div>
            </div>
          </div>
        ) : (
          <div className="mobilemain">
            {" "}
            {/* This should handle the mobile version if needed */}
            {/* Mobile version content */}
            <div className="row">
              <ToastContainer />
              {/* <div className="col-12 titlebar-mob"> */}
              <div className="row">
                <div className="col-2 pe-1">
                  <span
                    className="mobile-menu"
                    onClick={() => this.props.toggleMenu()}
                  >
                    <CommonIcon fileName={"Menu"} />
                  </span>
                </div>
                <div className="col-8 ps-2">
                  <span className="headerform-mobile">Settings</span>
                </div>
                {/* <div className='col-2 pt-1 col-sm-2'>
                                    <button className='btn-fun ps-3 pe-3' type="button" onClick={this.toggleWebFilter}><CommonIcon fileName={'Filter'} /> </button>{' '}
                                </div> */}
              </div>
              <div className="row w-100 ms-3">
                <div className="col-12 ">
                  <TabContext value={this.state.value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList onChange={this.handleChange}>
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Global Settings"
                          value="1"
                          className="m1 p0 mr-30"
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="SSO"
                          value="2"
                          className="p0 mr-30"
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Meeting Configuration"
                          value="3"
                          className="p0 mr-30"
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Tenant Admin Center"
                          value="4"
                          className="p0 mr-30"
                        />
                      </TabList>
                    </Box>
                    <TabPanel value="1" className="mt-2 ">
                      <GlobalSettings />
                    </TabPanel>
                    <TabPanel value="2" className="mt-2 ">
                      <SSO handleLogout={this.props.handleLogout} isSSO={this.state.isSSO}  />
                    </TabPanel>
                    <TabPanel value="3" className="mt-2 ">
                      <MeetingConfiguration />
                    </TabPanel>
                    <TabPanel value="4" className="mt-3 me-4">
                      <TenantAdminSettings />
                    </TabPanel>
                  </TabContext>
                </div>
              </div>
            </div>
          </div>
        )}
        <Backdrop className="spinner-backdrop" open={this.props.isLoading1}>
          <CircularProgress color="primary" />
        </Backdrop>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    // sideMenu: () => dispatch(sideMenu()) || false,
    dispatch,
  };
};
function mapStateToProps(state) {
  return {
    getapplication: state.applicationReducer.getapplication,
    getApplicationLicenseStatus:
      state.applicationReducer.getApplicationLicenseStatus,
    getApplicationUsers: state.applicationReducer.getApplicationUsers,
    auditLog: state.applicationReducer.auditLog,
    userRoleAssign: state.applicationReducer.userRoleAssign,
    isLoading: state.commonReducer.isLoading,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Settings)
);
